export const clientLogos = [
  'Harbor Hospitality Group',
  'Crestline Hotels',
  'Union Square Kitchens',
  'Meridian Retail Co.',
  'Southern Food Partners',
  'Ascend Franchise Group',
]

export const whatWeDo = [
  {
    icon: 'chart',
    title: 'Business Intelligence',
    description: 'Transform data into decisions.',
    detail:
      'Unify sales, labor, and cost data into a single source of truth so every decision starts with facts, not guesswork.',
  },
  {
    icon: 'settings',
    title: 'Operational Excellence',
    description: 'Standardize systems that improve performance.',
    detail:
      'Build repeatable processes and SOPs that hold up across shifts, teams, and locations.',
  },
  {
    icon: 'trending',
    title: 'Financial Performance',
    description: 'Increase profit margins through better cost controls.',
    detail:
      'Tighten purchasing, recipe costing, and labor spend to protect margin at every level of the P&L.',
  },
  {
    icon: 'monitor',
    title: 'Technology Solutions',
    description:
      'Software that gives you real-time visibility into your business.',
    detail:
      'Dashboards, reporting, and AI insights that surface what matters the moment it happens.',
  },
]

export const platformFeatures = [
  'Sales Analytics',
  'Labor Management',
  'Inventory',
  'Food Cost',
  'Purchasing',
  'Vendor Management',
  'KPI Tracking',
  'Multi-location Reporting',
  'AI Insights',
]

export const companyStats = [
  {
    value: '27+',
    label: 'Years of Industry Experience',
  },
  {
    value: 'Millions',
    label: 'Revenue Managed',
  },
  {
    value: 'Hundreds',
    label: 'Projects Completed',
  },
  {
    value: 'Thousands',
    label: 'Hours Saved',
  },
]

export const testimonials = [
  {
    quote:
      'ROI Complete gave us visibility we never had. Within one quarter we cut food cost by three points and finally understood where our money was going.',
    name: 'Denise Carter',
    role: 'Owner, Union Square Kitchens',
  },
  {
    quote:
      'The operational assessment alone paid for itself. They rebuilt our purchasing process and our vendors are now held to real standards.',
    name: 'Marcus Bell',
    role: 'VP of Operations, Harbor Hospitality Group',
  },
  {
    quote:
      'What sets them apart is the executive experience behind the software. They have run these businesses, so the advice is practical from day one.',
    name: 'Priya Raman',
    role: 'Director of Food & Beverage, Crestline Hotels',
  },
]
